/*jshint esversion: 6 */
import 'plyr/dist/plyr.css';

import Smooth from 'smooth-scrolling';
import PubSub from 'pubsub-js';
import classes from 'dom-classes';
import {LoadMaskImage, animateChildren} from '../helpers';
import plyr from 'plyr';
import {MatchHeight} from '../helpers';
import Barba from 'barba.js/src';

import {isIE9} from '../helpers';

export default class VerticalScroll extends Smooth {
    
    constructor(opt) {
        
        super(opt);
        this.createExtraBound();

        this.dom.section = opt.section;

        this.dom.topMenu = document.getElementById('siteHeader');
        this.resizing = false;
        this.lightBlocks = null;
        this.loadingNextPage = false;
        this.editMode = classes.has(document.getElementsByTagName('body')[0], 'edit-mode');
        this.cache = null;
        this.maskImageCache = null;
        this.animateCache = null;
        this.videoCache = null;
        this.previousScroll = 0;
        this.tabsOffset = 400;
        this.dom.divs = Array.prototype.slice.call(opt.divs, 0);
        this.dom.heading = this.dom.section.getElementsByClassName('page-title')[0].getElementsByClassName('container')[0];
        this.dom.scrollDown = this.dom.section.getElementsByClassName('scroll-down');
        this.dom.tabs = document.getElementById('tabs');
        this.dom.pageContent = document.getElementById('pageContent');
        this.accentColor = this.dom.section.getAttribute('data-color');
        this.speed = $('body, html').hasClass('mac-os') ? 5 : 1;
        this.stopped = false;
        this.hasInverseclass = $(this.dom.topMenu).has('inverse');
        this.dom.nextProject = $(this.dom.section).find('.next-project');
       
        this.cacheVisuals();

        PubSub.subscribe('scroll-top', () => {
            this.scrollTop();
        });

        // this.resize();
        window.smoothScrollInstances.push(this);

        if(isIE9()) {
            classes.add(this.dom.section, 'scrollbar-mode');
        }
        
    }

    createExtraBound() {
        ['getCache', 'inViewport', 'scrollTop', 'loadImage', 'animate', 'loadNextPage', 'playVideo', 'init', 'cacheVisuals', 'handleTabClick', 'calc', 'on']
        .forEach((fn) => this[fn] = this[fn].bind(this));
    }
    
    init() {
        super.init();
        super.resize();
        this.resize();

        if(this.dom.headerVideo) {
            classes.add(this.dom.headerVideo.parentNode, 'js-video');
        }   
    }

    on() {
        super.on();

        const videoPlayers = this.dom.videos.map( videoParent => videoParent.getElementsByTagName('video')[0] );
        const playing = plyr.setup( videoPlayers , {
            autoplay: true,
            clickToPlay: false,
            loop: true,
            hideControls: true,
            volume: 0,
            controls: [],
            keyboardShortcuts: {
                focused: false, global: false
            }
        });
        this.playingVideos = playing;
        
        const $domTabs = $(this.dom.tabs);
        $domTabs.on('click', 'a', this.handleTabClick);
        
        setTimeout(() => {
            const tabClone = $domTabs.clone(true, true);
            $(this.dom.topMenu).find('.inner-wrapper').append(tabClone); 
        }, 200);

        $(this.dom.scrollDown).on('click', () => this.scrollTo(window.innerHeight) );
    }

    cacheVisuals() {
        this.dom.maskImages = Array.prototype.slice.call(this.dom.section.getElementsByClassName('mask-image') || [], 0);
        this.dom.animate = Array.prototype.slice.call(this.dom.section.getElementsByClassName('animate-children') || [], 0);
        this.dom.videos = Array.prototype.slice.call(this.dom.section.getElementsByClassName('mask-video'), 0);
        this.dom.jsHeight = Array.prototype.slice.call(this.dom.section.getElementsByClassName('js-height'), 0);
        this.dom.headerVideo = document.getElementById('headerVideo');

        this.getCache();
    }

    handleTabClick(e) {
        e.preventDefault();

        var $clickedTarget = $(e.currentTarget);
        this.scrollTo(this.vars.current + this.dom.tabs.getBoundingClientRect().top);
        if($clickedTarget.hasClass('active')) return false;

        if (history.replaceState) {
            window.history.replaceState({url: $clickedTarget.attr('href'), type: 'tab'}, $clickedTarget.text(), $clickedTarget.attr('href'));
        }

        $clickedTarget.addClass('active').siblings().removeClass('active');
        $(this.dom.topMenu).find('.tabs a').eq($clickedTarget.index()).addClass('active').siblings().removeClass('active');
        $(this.dom.tabs).find('a').eq($clickedTarget.index()).addClass('active').siblings().removeClass('active');
        
        this.maskImageCache = this.animateCache = this.videoCache = null;
        
        $.get(e.currentTarget.getAttribute('href') )
            .then((data) => {
                TweenMax.to($(this.dom.pageContent), 0.3, {
                    autoAlpha: 0,
                    y: 100,
                    onComplete: () => {
                        $(this.dom.pageContent).html( $(data).find('#pageContent').html());
                        TweenMax.to($(this.dom.pageContent), 0.6, {
                            autoAlpha: 1,
                            y: 0
                        });

                        this.cacheVisuals();
                        this.off();
                        this.on();
                        this.resize();

                        setTimeout(() => this.resize(), 1000);

                        setTimeout(() => {
                            try {
                                let $video = $('.project-detail-page video');
                                $video.each(function(i,vid){
                                    vid.autoplay = true;
                                    vid.muted = true;
                                    let src = $('source', vid).data('src');
                                    if(src) {
                                        $('source', vid).attr('src',src);
                                        $('source', vid).data('src', null);
                                    }
                                });
                            }catch (e) {
                            }
                        }, 1000);
                    } 
                });
            }).fail(function() {
            alert( "error" );
        });
    }
    
    run() {
        super.run();

        if(this.vars.current > window.innerHeight && this.vars.current < this.previousScroll && !classes.has(this.dom.topMenu, 'active')) {
            classes.add(this.dom.topMenu, 'sticky');
        }

        else {
            classes.remove(this.dom.topMenu, 'sticky');
            (this.vars.current > window.innerHeight) ? classes.remove(this.dom.topMenu, 'inverse') : this.hasInverseclass ? classes.add(this.dom.topMenu, 'inverse') : '';
            if(classes.has(this.dom.topMenu, 'active')) {
                classes.add(this.dom.topMenu, 'inverse');
            }
        }
        if(this.dom.tabs) {
            if(this.vars.current > this.tabsOffset && !classes.has(this.dom.topMenu, 'active')) {
                classes.add(this.dom.topMenu, 'show-tabs'); classes.add(this.dom.tabs, 'sticky');
            } else {
                classes.remove(this.dom.topMenu, 'show-tabs'); classes.remove(this.dom.tabs, 'sticky');
            }
        }
        
    
        this.previousScroll = this.vars.current;

        // (!this.editMode && this.dom.nextProject.offset().top <= this.dom.nextProject.outerHeight(true)) ? this.goTo(this) : '';
        if(!this.editMode && this.vars.current >= this.vars.bounding - 5) this.loadNextPage();
        
        this.dom.divs.forEach(this.inViewport);
        this.dom.maskImages.forEach(this.loadImage);
        this.dom.animate.forEach(this.animate);
        // this.dom.videos.forEach(this.playVideo);
        
        this.dom.section.style[this.prefix] = this.getTransform(this.vars.current * -1);
        
        this.dom.heading.style[this.prefix] = this.getTransform(this.vars.current * -0.5);
    }

    calc(e) {

        let isSafari = false;
        const ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') !== -1) {
            isSafari = !(ua.indexOf('chrome') > -1)
        }
        if(isSafari){
            e.originalEvent.preventDefault();
        }


        const delta = !this.editMode && this.dom.nextProject.offset().top <= (this.dom.nextProject.outerHeight(true) + 400) && (e.deltaY < -10) ? Math.max(e.deltaY, -50) : e.deltaY; 

        this.vars.target += -(delta / this.speed);

        this.clampTarget();
    }

    resize() {
        this.resizing = true;

        super.resize();

        super.calc({
            deltaX: 0,
            deltaY: 0
        });

        this.getCache();

        MatchHeight(this.dom.jsHeight);

        if(isIE9()) {
            $(this.dom.section).height( this.vars.height + window.innerHeight );
        }

        this.vars.bounding = this.dom.section.getBoundingClientRect().height - this.vars.height;
        if(this.dom.tabs) this.tabsOffset = this.dom.tabs.getBoundingClientRect().top + this.vars.current;
        this.resizing = false;
    }

    scrollTop() {
        this.vars.target = 0;

        const timer = setInterval(() => {
            if(this.vars.current < 10) {
                clearInterval(timer);
                PubSub.publish('scroll-complete');
                this.run = () => {return;}
            }            
        }, 200);
    }
    
    getCache() {
        this.cache = [];

        this.dom.divs.forEach((el, index) => {

            el.style.display = 'block';
            el.style.transform = 'none';

            const scrollY = this.vars.target;
            const bounding = el.getBoundingClientRect();
            const bounds = {
                el: el,
                state: true,
                top: bounding.top + scrollY,
                left: bounding.left,
                center: bounding.height / 2,
                bottom: bounding.bottom + scrollY,
                speed: el.getAttribute('data-speed') || '-1'
            };
            this.cache.push(bounds);
        });

        this.animateCache = [];
        this.dom.animate.forEach((el, index) => {
            el.style.opacity = 0;

            const scrollY = this.vars.target;
            const bounding = el.getBoundingClientRect();
            const bounds = {
                el: el,
                state: true,
                top: bounding.top + scrollY,
                left: bounding.left,
                center: bounding.height / 2,
                bottom: bounding.bottom + scrollY
            };

            this.animateCache.push(bounds);
        });

        this.maskImageCache = [];
        this.dom.maskImages.forEach((el, index) => {
            el.style.display = 'block';

            el.getElementsByClassName('mask--image-mask')[0].style.backgroundColor = this.accentColor;

            const scrollY = this.vars.target;
            const bounding = el.getBoundingClientRect();
            const bounds = {
                el: el,
                state: true,
                top: bounding.top + scrollY,
                left: bounding.left,
                center: bounding.height / 2,
                bottom: bounding.bottom + scrollY
            };
            this.maskImageCache.push(bounds);
        });

        this.videoCache = [];
        this.dom.videos.forEach((el, index) => {
            el.style.display = 'block';

            const scrollY = this.vars.target;
            const bounding = el.getBoundingClientRect();
            const bounds = {
                el: el,
                state: true,
                top: bounding.top + scrollY,
                left: bounding.left,
                center: bounding.height / 2,
                bottom: bounding.bottom + scrollY
            };
            this.videoCache.push(bounds);
        });
        
        // get bounding value based on the container (.vs-section) height        
        this.vars.bounding = this.dom.section.getBoundingClientRect().height - (this.vars.native ? 0 : this.vars.height);
    }

    inViewport(el, index) {

        if(!this.cache || this.resizing) return;
        
        const cache = this.cache[index];
        const current = this.vars.current;
        
        const transform = ((cache.top + cache.center) - current) * cache.speed;
        const top = Math.round((cache.top + transform) - current);
        const bottom = Math.round((cache.bottom + transform) - current);
        const inview = bottom > 0 && top < this.vars.height;

        if(inview) {         
            el.style.display = 'block';
            el.style[this.prefix] = this.getTransform(current * 0.80);
            
        }
    }

    loadImage(el, index) {
        if(!this.maskImageCache || this.resizing) return;
        
        const cache = this.maskImageCache[index];
        const current = this.vars.current;
        
        const transform = ((cache.top + cache.center) - current) * cache.speed;
        // const top = Math.round((cache.top + transform) - current)
        const top = Math.round(cache.top - window.innerHeight);
        const bottom = Math.round((cache.bottom + transform) - current);
        const inview = current >= top && current <= cache.bottom;

        if(inview) {         
            LoadMaskImage(el, () => this.resize(), 200);
            this.maskImageCache.splice(index, 1);
            this.dom.maskImages.splice(index, 1);
        }
    }

    animate(el, index) {
        if(!this.animateCache || this.resizing) return;
        
        const cache = this.animateCache[index];
        const current = this.vars.current;
        
        const transform = ((cache.top + cache.center) - current) * cache.speed;
        // const top = Math.round((cache.top + transform) - current)
        const top = Math.round(cache.top - window.innerHeight);
        const bottom = Math.round((cache.bottom + transform) - current);
        const inview = current >= top && current <= cache.bottom;
        if(inview) {         
            animateChildren(el);
            this.animateCache.splice(index, 1);
            this.dom.animate.splice(index, 1);
        }
    }

    playVideo(el, index) {
    }

    loadNextPage() {
        if(this.loadingNextPage === true) return;
        // console.log('laodmext')
        this.loadingNextPage = true;
        try {
            window.stop();
        } catch (exception) {
            document.execCommand('Stop');
        }
        Barba.Pjax.goTo($(this.dom.section).find('.next-project a').attr('href'));
        $(this.dom.section).find('.next-project__scroll-more').text('Loading..');
        
        this.run = () => {return;}
        
        if(this.dom.tabs)  {
            const tabs = this.dom.topMenu.getElementsByClassName('tabs')[0];
            if (tabs) tabs.parentNode.removeChild(tabs);
        }
        
        const timeout = setInterval(() => {
            if(this.vars.current >= this.vars.bounding - 1) {
                this.off();
                clearInterval(timeout);
            }
        }, 100);
    }

    off() {
        super.off();

        if(this.dom.tabs) {
            $(this.dom.tabs).off('click');
            $(this.dom.tabs).off('click', 'a');
        }

        $(this.dom.scrollDown).off('click');
        

        try {
            this.playingVideos.forEach( player => player.destroy() );
        }
        catch(e) {
            console.log('failed to stop videos');
        }
    }

}


// WEBPACK FOOTER //
// ./app/components/scrolling/vertical-scroll.js